import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsManufactory = React.forwardRef(
  (props: SvgIconProps, ref: any) => {
    return (
      <SvgIcon {...props} ref={ref}>
        <g fill="currentColor">
          <path
            d="M22.5346642,8.6970367v0.000001L12.1947556,5.3641105c-0.126771-0.0391827-0.260457-0.0391827-0.3849239,0
		L9.3596935,6.1547022L8.7650223,1.2498133c-0.0391846-0.3342147-0.3157759-0.5831466-0.64077-0.5831466H5.5381222
		c-0.3249941,0-0.6015854,0.2512378-0.6407695,0.5831466L4.0975423,7.8488231L1.4676193,8.6970367
		C1.1979424,8.7846231,1.0135481,9.0427761,1.0135481,9.3331976v13.3340101c0,0.3687897,0.2904218,0.6661263,0.64538,0.6661263
		h20.6821232c0.3572636,0,0.64538-0.2973366,0.64538-0.6661263V9.3331976
		C22.9887352,9.0427761,22.8043404,8.7846251,22.5346642,8.6970367z M6.1097445,1.9989164H7.552629L8.1058121,6.555759
		L5.4528399,7.4108882L6.1097445,1.9989164z M13.9395847,22.0010853h-3.8768892v-2.6668034h3.8768892V22.0010853z
		 M21.6956692,22.0010853h-6.4630203v-3.3329258c0-0.3687897-0.2904196-0.6661263-0.6453791-0.6661263H9.4150105
		c-0.3572636,0-0.64538,0.2973366-0.64538,0.6661263v3.3329258H2.3066111V9.8241482l9.6945295-3.1254835l9.6945286,3.1254835
		V22.0010853z"
          />
          <path
            d="M3.5996766,12.6661253v2.6668024c0,0.3687878,0.290422,0.6661243,0.64538,0.6661243H19.754921
		c0.3572636,0,0.64538-0.2973366,0.64538-0.6661243v-2.6668024C20.400301,12.2973366,20.1098804,12,19.754921,12H4.2450566
		C3.8877928,12,3.5996766,12.2996407,3.5996766,12.6661253z M16.5257149,13.3345537h2.5861301v1.3322487h-2.5861301V13.3345537z
		 M12.6465206,13.3345537h2.5861301v1.3322487h-2.5861301V13.3345537z M8.7696304,13.3345537h2.5861301v1.3322487H8.7696304
		V13.3345537z M4.8927412,13.3345537h0.000001h2.5861287v1.3322487H4.8927412V13.3345537z"
          />
        </g>
      </SvgIcon>
    );
  }
);

export default AppIconsManufactory;
